const MARKDOWN_TABLE_DIVIDER = /^\s*\|?(?:\s*:?-{3,}:?\s*\|)+\s*:?-{3,}:?\s*\|?\s*$/m;
const MARKDOWN_HTML_TAG = /^\s*<\/?[a-z][^>]*>\s*$/im;
const MARKDOWN_FOOTNOTE = /(?:^\s*\[\^[^\]]+\]:|\[\^[^\]]+\])/m;
const URI_SCHEME = /^[a-z][a-z\d+.-]*:/i;
const SAFE_URI_SCHEME = /^(?:https?|mailto|tel):/i;

/** Reject executable or local URL schemes while preserving relative project links. */
export function isSafeMarkdownLink(url: string): boolean {
  const value = url.trim();
  return value.length > 0 && (!URI_SCHEME.test(value) || SAFE_URI_SCHEME.test(value));
}

/**
 * Lexical deliberately handles the common project-writing subset. Content
 * outside that subset stays in Markdown mode so switching editors can never
 * silently discard source syntax.
 */
export function hasUnsupportedVisualMarkdown(markdown: string): boolean {
  return (
    MARKDOWN_TABLE_DIVIDER.test(markdown) ||
    MARKDOWN_HTML_TAG.test(markdown) ||
    MARKDOWN_FOOTNOTE.test(markdown)
  );
}
